import classNames from 'classnames';
import React from 'react';
import Icon from '../Icon/Icon';
var css = {
  "stat": "rui-9sOTf",
  "text": "rui-co1F6"
};
var Statistic = function Statistic(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 32 : _ref$iconSize,
    label = _ref.label,
    _ref$hideLabel = _ref.hideLabel,
    hideLabel = _ref$hideLabel === void 0 ? false : _ref$hideLabel,
    value = _ref.value,
    _ref$dataAutId = _ref['data-aut-id'],
    dataAutId = _ref$dataAutId === void 0 ? '' : _ref$dataAutId;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.stat, className),
    "data-aut-id": dataAutId
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    size: iconSize
  }), !hideLabel && /*#__PURE__*/React.createElement("span", {
    className: css.text
  }, label, ":"), /*#__PURE__*/React.createElement("span", null, value));
};
export default Statistic;